import React, { useEffect, useState } from "react";
import { getAllSubsites, allSubsites, subsiteTotalCount } from '../../reducers/subsite';
import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import MSMPagination from '../MSMPagination';
import CreateSubsiteModal from '../modals/CreateSubsiteModal';
import Button from "react-bootstrap/Button";
import { PersonCircle, Diagram2, Cart, Search } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';
import Form from "react-bootstrap/Form";
import { Formik } from 'formik';
import * as Yup from 'yup';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SubsiteService from "../../services/subsite.service";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

const AdminSubsites = () => {
  const subsites = useSelector(allSubsites);
  const subsiteStatus = useSelector(state => state.subsite.status);
  const subsiteTotal = useSelector(subsiteTotalCount);
  const [modalShow, setModalShow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [range, setRange] = useState([1, 10]);
  const [reload, setReload] = useState(false);
  const [type, setType] = useState("credit");

  const [items, setItems] = useState([]);
  const [class1BoxFee, setClass1BoxFee] = useState(0);
  const [class4BoxFee, setClass4BoxFee] = useState(0);

  const [class1MaxWeight, setClass1MaxWeight] = useState(0);
  const [class2MaxWeight, setClass2MaxWeight] = useState(0);
  const [class3MaxWeight, setClass3MaxWeight] = useState(0);

  const [class1WeightFactor, setClass1WeightFactor] = useState(0);
  const [class2WeightFactor, setClass2WeightFactor] = useState(0);
  const [class3WeightFactor, setClass3WeightFactor] = useState(0);
  const [class4WeightFactor, setClass4WeightFactor] = useState(0);

  const [calcByOverage, setCalcByOverage] = useState(false);

  const [subsiteShipping, setSubsiteShipping] = useState({});

  const [resetPagination, setResetPagination] = useState(false);
  let perPage = 10;

  const userValidationSchema = Yup.object().shape({
    subsitename: Yup.string()
      .required("*Subsite Name is required"),
    code: Yup.string()
      .required("*Code is required"),
    poc: Yup.string()
      .required("*Point of Contact is required"),
    logoFilename: Yup.string()
      .required("*Logo Filename is required"),
  });

  useEffect(() => {
    if (subsiteStatus === 'idle') {
      console.log("GET ALL SUBSITES");
      dispatch(getAllSubsites({ range: range }));
    } else if (subsiteStatus === 'succeeded' && subsites.length > 0) {
      console.log("GET SUBSITE SHIPPING");
      SubsiteService.getSubsiteShipping(subsites[0].id).then((response) => {
        console.log("Shipping Data", response.data);
        setSubsiteShipping(response.data);
        var itemsNew = []
        for (let i = 0; i < 10; i++) {
          if (response.data["item" + (i + 1)]) {
            itemsNew.push(response.data["item" + (i + 1)]);
          }
        }
        setItems(itemsNew);
        setClass1BoxFee(response.data.class1BoxFee);
        setClass4BoxFee(response.data.class4BoxFee);


        setClass1MaxWeight(response.data.class1MaxWeight);
        setClass2MaxWeight(response.data.class2MaxWeight);
        setClass3MaxWeight(response.data.class3MaxWeight);

        setClass1WeightFactor(response.data.class1WeightFactor);
        setClass2WeightFactor(response.data.class2WeightFactor);
        setClass3WeightFactor(response.data.class3WeightFactor);
        setClass4WeightFactor(response.data.class4WeightFactor);
        setCalcByOverage(response.data.calcByOverage);
      });
    }
  }, [subsiteStatus, dispatch]);

  useEffect(() => {
    dispatch(getAllSubsites({ range: range }));
  }, [range, reload, dispatch]);

  console.log("SUBSITE STATUS", subsiteStatus);

  const saveCCOnly = () => {
    SubsiteService.updateShipping(subsites[0].id,
      {
        class1BoxFee: class1BoxFee,
        class4BoxFee: class4BoxFee,
        class1MaxWeight: class1MaxWeight,
        class2MaxWeight: class2MaxWeight,
        class3MaxWeight: class3MaxWeight,
        class1WeightFactor: class1WeightFactor,
        class2WeightFactor: class2WeightFactor,
        class3WeightFactor: class3WeightFactor,
        class4WeightFactor: class4WeightFactor,
        items: items,
        calcByOverage: calcByOverage

      });
  }

  const updateItem = (itemId, value) => {
    console.log("UPDATE CC ITEM", itemId, value);
    var newItems = [...items];
    newItems[itemId] = value;
    setItems(newItems);
  }


  const nth = (d) => {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  };

  const cc_rows = [];
  const rows = [];

  for (let i = 0; i < 10; i++) {
    // note: we are adding a key prop here to allow react to uniquely identify each
    // element in this array. see: https://reactjs.org/docs/lists-and-keys.html
    rows.push(
      <Row style={{ border: "1px solid black" }}>
        <Col className="title" lg="2">
          {i + 1 + nth(i + 1)} item
        </Col>
        <Col className="value" lg="2">
          <input id={"item-" + (i + 1)}></input>
        </Col>
      </Row>);
    cc_rows.push(
      <Row style={{ border: "1px solid black" }}>
        <Col className="title" lg="2">
          {i + 1 + nth(i + 1)} item
        </Col>
        <Col className="value" lg="2">
          <input id={"item-" + (i + 1)} onChange={(e) => updateItem(i, e.target.value)} value={items[i]} ></input>
        </Col>
      </Row>);
  }

  return (
    <div className="user-details-container">
      <Container className="user-data">
        <Row>
          <Col className="icon">
            <h2>Shipping Rules</h2>
            <ul>
              <li>Class 1: Items less than {class1MaxWeight} lbs and are charged {class1BoxFee} + flat fee for item number</li>
              <li>Class 2: Items more than {class1MaxWeight} lbs and less than {class2MaxWeight} lbs and are charged {class1BoxFee} + weight * {class2WeightFactor} </li>
              <li>Class 3: Items more than {class2MaxWeight} lbs and less than {class3MaxWeight} lbs and are charged {class1BoxFee} + weight * {class3WeightFactor} </li>
              <li>Class 4: Items more than {class3MaxWeight} lbs and are charged {class4BoxFee} + weight * {class4WeightFactor} </li>

            </ul>
            <Row>
              <Col>
                <Form.Check 
                  key={"calcByOverage"}
                  type="switch"
                  id="calcByOverage"
                  label="Calculate shipping by overage"
                  checked={calcByOverage}
                  onChange={(e) => setCalcByOverage(e.target.checked)}
                  style={{ marginLeft: 30 }}
                />

              </Col>
            </Row>
            <Row>
              <Col>
                <Tabs
                  defaultActiveKey="class1"
                  id="uncontrolled-tab-example"
                  className="tabContainer"
                >
                  <Tab eventKey="class1" title="Class 1">
                    Items under {class1MaxWeight} lbs
                    <Container>
                      <Row style={{ border: "1px solid black" }}>
                        <Col className="title" lg="2">
                          Class 1 Max Weight
                        </Col>
                        <Col className="value" lg="2">
                          <input id="cc-medium-min" onChange={(e) => setClass1MaxWeight(e.target.value)} value={class1MaxWeight}></input>
                        </Col>
                      </Row>
                      <Row style={{ border: "1px solid black" }}>
                        <Col className="title" lg="2">
                          Class 1 Box Fee
                        </Col>
                        <Col className="value" lg="2">
                          <input id="cc-initial" onChange={(e) => setClass1BoxFee(e.target.value)} value={class1BoxFee}></input>
                        </Col>
                      </Row>
                      {cc_rows}

                    </Container>
                  </Tab>
                  <Tab eventKey="class2" title="Class 2">
                    Items between {class1MaxWeight} lbs and {class2MaxWeight} lbs
                    <Container>
                      <Row style={{ border: "1px solid black" }}>
                        <Col className="title" lg="2">
                          Class 2 Max Weight
                        </Col>
                        <Col className="value" lg="2">
                          <input id="cc-medium-min" onChange={(e) => setClass2MaxWeight(e.target.value)} value={class2MaxWeight}></input>
                        </Col>
                      </Row>
                      <Row style={{ border: "1px solid black" }}>
                        <Col className="title" lg="2" >
                          Class 2 Weight Factor
                        </Col>
                        <Col className="value" lg="2">
                          <input id="cc-md-percent" onChange={(e) => setClass2WeightFactor(e.target.value)} value={class2WeightFactor}></input>
                        </Col>
                      </Row>
                      <Row style={{ border: "1px solid black" }}>
                        <Col className="title" lg="2" >
                          Example
                        </Col>
                        <Col className="value" lg="2">
                          Largest Class 2 Item would cost ({class2MaxWeight} * {class2WeightFactor}) {(class2MaxWeight * class2WeightFactor).toLocaleString(undefined, {
                            style: "currency",
                            currency: "USD",
                          })}
                        </Col>
                      </Row>
                    </Container>
                  </Tab>
                  <Tab eventKey="class3" title="Class 3">
                    Items between {class2MaxWeight} lbs and {class3MaxWeight} lbs
                    <Container>
                      <Row style={{ border: "1px solid black" }}>
                        <Col className="title" lg="2">
                          Class 3 Max Weight
                        </Col>
                        <Col className="value" lg="2">
                          <input id="cc-medium-min" onChange={(e) => setClass3MaxWeight(e.target.value)} value={class3MaxWeight}></input>
                        </Col>
                      </Row>
                      <Row style={{ border: "1px solid black" }}>
                        <Col className="title" lg="2" >
                          Class 3 Weight Factor
                        </Col>
                        <Col className="value" lg="2">
                          <input id="cc-md-percent" onChange={(e) => setClass3WeightFactor(e.target.value)} value={class3WeightFactor}></input>
                        </Col>
                      </Row>
                      <Row style={{ border: "1px solid black" }}>
                        <Col className="title" lg="2" >
                          Example
                        </Col>
                        <Col className="value" lg="2">
                          Largest Class 3 Item would cost ({class3MaxWeight} * {class3WeightFactor}) {(class3MaxWeight * class3WeightFactor).toLocaleString(undefined, {
                            style: "currency",
                            currency: "USD",
                          })}
                        </Col>
                      </Row>
                    </Container>
                  </Tab>
                  <Tab eventKey="class4" title="Class 4">
                    Items more than {class3MaxWeight} lbs
                    <Container>
                      <Row style={{ border: "1px solid black" }}>
                        <Col className="title" lg="2">
                          Class 4 Max Weight
                        </Col>
                        <Col className="value" lg="2">
                          <input id="cc-medium-min" onChange={(e) => setClass3MaxWeight(e.target.value)} value={class3MaxWeight}></input>
                        </Col>
                      </Row>
                      <Row style={{ border: "1px solid black" }}>
                        <Col className="title" lg="2">
                          Class 4 Box Fee
                        </Col>
                        <Col className="value" lg="2">
                          <input id="cc-initial" onChange={(e) => setClass4BoxFee(e.target.value)} value={class4BoxFee}></input>
                        </Col>
                      </Row>
                      <Row style={{ border: "1px solid black" }}>
                        <Col className="title" lg="2" >
                          Class 4 Weight Factor
                        </Col>
                        <Col className="value" lg="2">
                          <input id="cc-md-percent" onChange={(e) => setClass4WeightFactor(e.target.value)} value={class4WeightFactor}></input>
                        </Col>
                      </Row>
                      <Row style={{ border: "1px solid black" }}>
                        <Col className="title" lg="2" >
                          Example
                        </Col>
                        <Col className="value" lg="2">
                          Smallest Class 4 Item would cost ({class4BoxFee} + ({class3MaxWeight} * {class4WeightFactor})) {(class4BoxFee + class3MaxWeight * class4WeightFactor).toLocaleString(undefined, {
                            style: "currency",
                            currency: "USD",
                          })}
                        </Col>
                      </Row>
                    </Container>
                  </Tab>
                </Tabs>

              </Col>
            </Row>

            <Button onClick={saveCCOnly}>Save Credit Card Shipping</Button>
          </Col>
        </Row>
      </Container>
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
  );
};
export default AdminSubsites;

